module.exports = __webpack_public_path__ + "static/media/abstract-ganja-leaf.7accc6de.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/abstract-ganja-leaf.png
 ** module id = 765
 ** module chunks = 0
 **/